const state = {
    searchInputValue: '', //搜索输入框取值
    title: '你看书我买单', //二级页面的标题
    tabbarIndex: 0, //tabbar选中状态索引
    userSex: '请选择性别', //用户性别
    userLogin: true,
    userBinding: false,
    userAddress: null,
    isLoading: false,
    book: {
        bookExt: {}
    },
    avatar: '/style/imgs/mrtx.png',
    name: '您还没有书堆号',
    nickname: '您尚未登录，点击登录',
    mobile: '',
    baseurl: 'http://sdr.shuduier.cn',
    type: 0,
    orgLogo: '',
    orgName: '书堆儿'
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js